import { render, staticRenderFns } from "./CompanySearchResultsPanel.vue?vue&type=template&id=5bafa11c&scoped=true&"
import script from "./CompanySearchResultsPanel.vue?vue&type=script&setup=true&lang=js&"
export * from "./CompanySearchResultsPanel.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CompanySearchResultsPanel.vue?vue&type=style&index=0&id=5bafa11c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bafa11c",
  null
  
)

export default component.exports